import { Col, TextInputField } from '@/components';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ProjectNumbersColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<SharedSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <TextInputField
        name="projectNumbers"
        label={t('project-number')}
        hint={t('hint-search-project-number')}
        control={control}
        errors={errors}
        allowClear
      />
    </Col>
  );
});
